import { useCallback, useMemo } from 'react'

// Realm functionality deprecated - returning stub

/**
 * The `useMongo` hook (deprecated - Realm removed)
 *
 * @returns {object} the context object
 */
function useMongo () {
  const loginRealm = useCallback(async () =>
    // Realm deprecated - no-op
    null
  , [])

  const ctx = useMemo(
    () => ({
      loginRealm
    }),
    []
  )

  return ctx
}

// Export
export default useMongo
